export default __webpack_public_path__ + "static/media/mabe.0a029612.png";